<template>
  <div class="add-qq-card"  @click="$emit('onAddQQ', data)">
    <div class="content">
      <h2 class="title"><i class="icon-qq"></i>添加QQ联系人</h2>
      <p class="thumb"><a href="javascript:;" class="action"><img :src="message.avatar" v-defaultAvatar></a></p>
      <dl class="detail">
        <dt><a href="javascript:;" class="action">{{ message.name }}</a></dt>
        <dd><a href="javascript:;" class="action">{{ message.showQQ }}</a></dd>
      </dl>
    </div>
  </div>
</template>

<script>
const DEFAULT_AVATAR = require('@/static/img/default-avatar.png');
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  directives: {
    // 当头像加载失败时，使用默认头像，可以考虑放到全局
    defaultAvatar: {
      bind(el) {
        /* eslint-disable no-param-reassign */
        el.addEventListener('error', el => el.target.src = DEFAULT_AVATAR, {
          once: true,
        });
      },
    },
  },
  computed: {
    message() {
      return this.data.msgBody ?? {};
    },
  },
  methods: {
  },
  mounted() {
    console.log('[sc]', this.data);
  },
};
</script>

<style lang="less" scoped>
.add-qq-card {
  width: 193px;
  height: 89px;
  background-color: #fff;
  border: 1px solid #cedae1;
  border-radius: 4px;
  line-height: 1;
  .content {
    overflow: hidden;
    position: relative;
    padding-top: 10px;
    .title {
      margin: 0 0 8px 8px;
      font-size: 12px;
      color: #8b939c;
      font-weight: 400;
      .icon-qq {
        margin-right: 4px;
      }
    }
    .thumb {
      float: left;
      width: 50px;
      height: 50px;
      margin: 0 10px 0 15px;
      font-size: 0;
      a {
        text-decoration: none;
        color: #444;
        img {
          width: 50px;
          height: 50px;
          border-radius: 50px;
        }
      }
    }
    .detail {
      margin: 0;
      position: relative;
      overflow: hidden;
      padding-top: 10px;
      font-size: 14px;
      color: #333;
      dd {
        margin: 0;
      }
      a {
        width: 100%;
        display: inline-block;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
